import { Skeleton } from '@chakra-ui/react';
import { Table } from '@morressier/alembic';

const ListLoader = () => (
  <>
    {[1, 2].map(k => (
      <Table.Row key={k} paddingY={4} gap={2}>
        <Skeleton width={'100%'} height={10} />
      </Table.Row>
    ))}
  </>
);

export default ListLoader;
